import { render, staticRenderFns } from "./OriginInfo.vue?vue&type=template&id=72bfd1c5&scoped=true"
import script from "./OriginInfo.vue?vue&type=script&lang=ts"
export * from "./OriginInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bfd1c5",
  null
  
)

export default component.exports